<template>
  <page-listado>
    <page-header title="Formas de pago">
      <b-button variant="primary" size="sm" to="/formasPago/crear">
        <v-icon name="plus" width="16" />
        Crear forma de pago
      </b-button>
    </page-header>
    <tabla :formas-pago="formasPago" />
  </page-listado>
</template>

<script>
import api from "@/services/formasPago.js";
import Tabla from "./TablaFormasPago.vue";
export default {
  components: { Tabla },
  data() {
    return {
      formasPago: [],
    };
  },
  watch: {
    "$route.params": {
      handler: function () {
        this.listar();
      },
      deep: true,
      immediate: true,
    },
  },
  methods: {
    async listar() {
      this.formasPago = await api.listar(this.$route.query);
    },
  },
};
</script>
